import { render, staticRenderFns } from "./CheckProfile.vue?vue&type=template&id=20e050fa&scoped=true"
import script from "./CheckProfile.vue?vue&type=script&lang=js"
export * from "./CheckProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e050fa",
  null
  
)

export default component.exports